// SQL Server's FOR JSON PATH preserves column aliases exactly as written in the query (PascalCase,
// matching table column names) rather than camelCasing them. The rest of this app's new Selection
// services/hooks/components are written assuming normal camelCase JS objects, so responses are
// normalized once here (immediately after JSON.parse) rather than reading PascalCase everywhere.
export function toCamelCaseDeep(value) {
  if (Array.isArray(value)) {
    return value.map(toCamelCaseDeep);
  }
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, v]) => [
        key.charAt(0).toLowerCase() + key.slice(1),
        toCamelCaseDeep(v),
      ])
    );
  }
  return value;
}
